export function decodeJwtPayload(token) {
  if (!token || typeof token !== 'string') return null
  const parts = token.split('.')
  if (parts.length < 2) return null
  try {
    let payload = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    while (payload.length % 4 !== 0) payload += '='
    return JSON.parse(atob(payload))
  } catch {
    return null
  }
}

export function isTokenExpired(token) {
  const payload = decodeJwtPayload(token)
  if (!payload?.exp) return true
  return payload.exp * 1000 < Date.now()
}

export function tokenLooksValid(token) {
  return !!token && !isTokenExpired(token)
}

export function authHeaders() {
  const token = localStorage.getItem('token')
  if (!token) return {}
  return {
    Authorization: `Bearer ${token}`,
    'X-Auth-Token': token
  }
}
